<div class="auth-wrapper">
  <div class="align-items-center grid h-full">
    <div class="col-6 h-full">
      <div class="gc-auth-leftPanel">
        <div class="gc-idnty-container">
          <div class="gc-logo">
            <a href=""><img src="../../assets/images/io-logo-green.svg" alt="io-logo.svg"/></a>
          </div>
          <div class="">
            <p class="mt-5 ">{{logoText}}</p>
          </div>
        </div>
        <div class="gc-auth-slider">
          <!-- <app-multi-slider></app-multi-slider> -->
          <img src="../../assets/images/banner.svg" alt="banner.svg"/>
        </div>
      </div>
    </div>
    <div
      class="col-6 relative justify-content-center flex align-items-center h-full"
    >
      <div class="gc-auth-form-container">
        <div>
          <span class="back-arrow" (click)="navigateToPreviousPage()">
            <em class="pi pi-arrow-left"></em>
          </span>
        </div>
        <h1>Create New Password</h1>
        <p>
          Enter the verification code that has been sent to your registered
          email address.
        </p>
        <form
          (ngSubmit)="submitConfirmPasswordForm(confirmPasswordForm)"
          #confirmPasswordForm="ngForm"
        >
        <div  class="mt-1 mb-5">
          <input type="email" pInputText [(ngModel)]="email" #inputFieldEmail="ngModel" name="email" placeholder="Email"
                 required email [ngClass]="{'error-border': (inputFieldEmail.touched && !inputFieldEmail.value) ||
                  (inputFieldEmail.touched && inputFieldEmail.invalid)}">
          </div>

          <div class="mt-1 mb-5">
            <input type="text" pInputText [(ngModel)]="verificationCode" name="verificationCode" #inputFieldVerificationCode="ngModel"
                   placeholder="Verification Code" required [ngClass]="{'error-border': (inputFieldVerificationCode.touched && !inputFieldVerificationCode.value)}">
          </div>


          <div class="mt-1 mb-5">
            <p-password
              [(ngModel)]="newPassword"
              (ngModelChange)="checkPasswordStrength()"
              [feedback]="false"
              name="newpassword"
              [toggleMask]="true"
              placeholder="New Password"
              pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
              required
              #inputFieldNewPassword="ngModel"
              [ngClass]="{'error-border-password': (inputFieldNewPassword.touched && !inputFieldNewPassword.value) ||
               (confirmPasswordDirty || passwordDirty) && repeatPassword !== newPassword}"
            >
            </p-password>
            <span class="password-req">
              {{PASSWORD_STRENGTH_VALIDATION_MESSAGE}}
            </span>
            <div class="flex gap-2 mt-3">
              <div
                class="password-check"
                [ngClass]="[
                  passwordStrength == 'Weak'
                    ? 'weak-password'
                    : '' || passwordStrength == 'Medium'
                    ? 'medium-password'
                    : '' || passwordStrength == 'Strong'
                    ? 'strong-password'
                    : ''
                ]"
              ></div>
              <div
                class="password-check"
                [ngClass]="[
                  passwordStrength == 'Weak'
                    ? 'weak-password'
                    : '' || passwordStrength == 'Medium'
                    ? 'medium-password'
                    : '' || passwordStrength == 'Strong'
                    ? 'strong-password'
                    : ''
                ]"
              ></div>
              <div
                class="password-check"
                [ngClass]="[
                  passwordStrength == 'Medium'
                    ? 'medium-password'
                    : '' || passwordStrength == 'Strong'
                    ? 'strong-password'
                    : ''
                ]"
              ></div>
              <div
                class="password-check"
                [ngClass]="
                  passwordStrength == 'Strong' ? 'strong-password' : ''
                "
              ></div>
            </div>
            <div class="password-strength-container">
              <span
                *ngIf="passwordStrength === 'Weak'"
                class="weak-password-text"
              >
                Weak
              </span>
              <span
                *ngIf="passwordStrength === 'Medium'"
                class="medium-password-text"
              >
                Medium
              </span>
              <span
                *ngIf="passwordStrength === 'Strong'"
                class="strong-password-text"
              >
                Strong
              </span>
            </div>
          </div>

          <div class="mt-1 mb-5">
            <p-password
              type="password"
              [(ngModel)]="repeatPassword"
              [toggleMask]="true"
              name="repeatpassword"
              [feedback]="false"
              placeholder="Confirm Password"
              (change)="confirmPasswordDirty = true"
              pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
              required
              #inputFieldRepeatPassword="ngModel"
              [ngClass]="{'error-border-password': (inputFieldRepeatPassword.touched && !inputFieldRepeatPassword.value) ||
               (confirmPasswordDirty || passwordDirty) && repeatPassword !== newPassword}"
            ></p-password>
            <span class="password-req c-r" *ngIf="(confirmPasswordDirty || passwordDirty) && repeatPassword !== newPassword">
              {{PASSWORDS_MUST_MATCH}}
            </span>
          </div>

          <button
            type="submit"
            class="login-btn"
          >
            Reset Password
          </button>
        </form>
      </div>

      <app-footer></app-footer>
    </div>
  </div>
</div>
